
import Gallery from "../../containers/Gallery/Gallery";
import Faq from "../Faq/Faq"
import NewsLink from "./NewsLink"
const News = function (props) {
    if(props.layout == "first"){
        let itemId = 0
        if(window.location && window.location.search)
        {
           const getParam = window.location.search.split("itemId=");
           if(getParam)
           {
            itemId = getParam[1];
           }
            //itemId = parseInt(url.searchParams.get("itemId"));
        }
        let items = props.items.filter((item)=>{
            return  !(item.NewsEmergency||false)
        });
        console.log("newsitems",items);
        ///take care of open via url
        return (
            <Faq items={items} 
            WpId={props.WpId}
            layout={props.layout}
            type={props.type}
            limit={props.limit}
            moreTitle={props.moreTitle}
            moreLink={props.moreLink}
            openItem={itemId | 0} 
            handleUserKeypress = {props.handleUserKeypress}/>
        );
    }
    else if(props.layout == "third"){  ///homepage slider
        let items = [...props.items].filter((item)=>{
            return !(item.NewsEmergency||false);
        }).slice(0,props.limit);

        let emergency = items.length ? [...props.items].find((item)=>{return item.NewsEmergency||false;}) : null;
        return (
            <Gallery items={items} 
            layout={props.layout} 
            moreLink={props.moreLink}
            moreTitle={props.moreTitle}
            mobile={props.mobile}
            slidesToShow={props.mobile ? 1 : 3}
            emergency={emergency}  />
        )
    }
}

export default News;